;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputDropdown', inputDropdown)

  /* @ngInject */
  function inputDropdown () {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        description: '@',
        placeholder: '@',
        modelPropertyName: '@',
        options: '<',
        optionsCount: '<',
        model: '=',
        value: '=',
        pricing: '<',
        pricingTooltip: '<',
        pricingTooltipPosition: '<',
        pricingData: '<',
        disabled: '<',
        mandatory: '<',
        readOnly: '<',
        loading: '<',
        change: '=',
        search: '<',
        fullSearch: '<',
        clearable: '<',
        multiple: '<',
        inline: '@',
        event: '@',
        enablePagination: '<',
        paginationFn: '=',
        externalSearchUrl: '@',
        apiResponseFn: '=',
        direction: '<',
        showDescriptionTooltip: '<',
        descriptionTooltipText: '@',
        onClick: '<'
      },
      templateUrl: '/core/directives/input-dropdown/input-dropdown-directive.html?$$REVISION$$',
      controller: 'InputDropdownController'
    }
  }
})()
